<template> 
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="8">
        <v-card class="ma-4 pa-2">
          <v-card-title>{{ t('Restablecer_Contraseña') }}</v-card-title>
          <v-card-text>
            <form @submit.prevent="resetPassword">
              <v-text-field
                v-model="newPassword1"
                :label="t('Nueva_contraseña')"
                type="password"
              />
              <v-text-field
                v-model="newPassword2"
                :label="t('Confirmar_nueva_contraseña')"
                type="password"
              />
              <v-btn type="submit" color="primary">
                {{ t('Restablecer_Contraseña') }}
              </v-btn>
            </form>
          </v-card-text>
        </v-card>

        <v-snackbar
          v-model="showSnackbar"
          :color="success ? 'green' : 'red'"
          :timeout="5000"
          bottom
        >
          {{ message }}
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { axios, setAuthToken } from '../axios';

// i18n
const { t } = useI18n();

// router & route
const router = useRouter();
const route = useRoute();

// form state
const newPassword1 = ref('');
const newPassword2 = ref('');

// snackbar state
const message = ref('');
const success = ref(false);
const showSnackbar = ref(false);

// route params as computed
const uid = computed(() => route.params.uid);
const token = computed(() => route.params.token);

// reset password action
async function resetPassword() {
  try {
    await axios.post(`reset/${uid.value}/${token.value}/`, {
      new_password1: newPassword1.value,
      new_password2: newPassword2.value,
      uid: uid.value,
      token: token.value,
    });

    message.value = t('Contraseña_restablecida_con_éxito');
    success.value = true;
    showSnackbar.value = true;

    // after showing success, log out
    setTimeout(() => {
      showSnackbar.value = false;
      logout();
    }, 3000);

  } catch (error) {
    if (error.response?.data) {
      const data = error.response.data;
      if (data.new_password1) {
        message.value = data.new_password1.join(' ');
      } else if (data.new_password2) {
        message.value = data.new_password2.join(' ');
      } else {
        message.value = t('Error_al_restablecer_contraseña');
      }
    } else {
      message.value = t('Error_al_restablecer_contraseña');
    }

    success.value = false;
    showSnackbar.value = true;

    setTimeout(() => {
      showSnackbar.value = false;
    }, 5000);
  }
}

// logout and redirect
function logout() {
  localStorage.removeItem('authToken');
  router.push('/login');
}

// on mount, set auth token for axios
onMounted(() => {
  const savedToken = localStorage.getItem('authToken');
  setAuthToken(savedToken);
});
</script>
